<div class="updox-message-list">
  <div class="updox-search-bar p-sm">
    <div class="input-group input-group-sm">
      <span class="input-group-addon"><i class="fa fa-search"></i></span>
      <input type="text" class="form-control" placeholder="Search messages..." [(ngModel)]="searchTerm" />
    </div>
  </div>

  <!-- Initial load spinner -->
  <div *ngIf="isLoading" class="text-center text-muted p">
    <i class="fa fa-spinner fa-spin mr-sm"></i> Loading...
  </div>

  <!-- Empty state -->
  <div *ngIf="!isLoading && filteredMessages.length === 0" class="text-center text-muted p-xl">
    <i class="fa fa-inbox fs30 d-block mb-sm"></i>
    <span *ngIf="messages.length === 0">No messages in this folder.</span>
    <span *ngIf="messages.length > 0">No results for "{{ searchTerm }}".</span>
  </div>

  <!-- Message rows -->
  <ul class="list-unstyled m0" *ngIf="!isLoading">
    <li *ngFor="let message of filteredMessages"
        class="updox-message-item"
        [class.active]="selectedMessage?.id === message.id"
        [class.unread]="!message.read"
        (click)="selectMessage(message)">
      <div class="media">
        <div class="media-left">
          <span class="updox-avatar fs14">{{ message.list_initial }}</span>
        </div>
        <div class="media-body">
          <div class="updox-flex-between">

            <span class="updox-sender fs14 fw-500" [class.fw-600]="!message.read">
  {{ (message.list_sender ? message.list_sender.split('@')[0] : '') | truncate:28:'...' }}
</span>
            <div class="updox-list-meta">
              <i class="fa fa-paperclip updox-list-attachment-icon"
                 *ngIf="message.has_attachments"
                 title="Has attachments"></i>
              <span class="updox-date text-muted fs13">
                {{ message.list_date | date:'MM/dd HH:mm' }}
              </span>
            </div>
          </div>
          <div class="updox-subject" [class.fw-500]="!message.read">
            {{ message.display_subject | truncate:38:'...' }}
          </div>
          <div class="updox-preview text-muted fs12">
            {{ message.preview | truncate:55:'...' }}
          </div>
          <div class="updox-msg-badges"
               *ngIf="message.added_to_medical_chart || message.reply_to_message_id || message.subject?.startsWith('Re:')">
            <span class="updox-badge-chart mr-sm" *ngIf="message.added_to_medical_chart">
              <i class="fa fa-check-circle mr-xs"></i>In Chart
            </span>
            <span class="updox-badge-reply text-secondary"
                  *ngIf="message.reply_to_message_id || message.subject?.startsWith('Re:')">
              <i class="fa fa-reply mr-xs"></i>Reply
            </span>
          </div>
        </div>
      </div>
    </li>
  </ul>

  <!-- Load More -->
  <div class="text-center p-sm" *ngIf="!isLoading && hasMore && !searchTerm">
    <button type="button" class="btn btn-default btn-sm btn-block"
            (click)="loadMore()" [disabled]="isLoadingMore">
      <i class="fa fa-spinner fa-spin mr-sm" *ngIf="isLoadingMore"></i>
      <i class="fa fa-chevron-down mr-sm" *ngIf="!isLoadingMore"></i>
      {{ isLoadingMore ? 'Loading...' : 'Load More' }}
    </button>
  </div>

  <!-- Count footer -->
  <div class="text-center text-muted fs12 p-sm"
       *ngIf="!isLoading && messages.length > 0 && !searchTerm">
    {{ messages.length }} of {{ totalCount }}
  </div>
</div>
